import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"


export const getAllPublicCourses = () => get(url.GET_ALL_PUBLIC_COURSES);
export const fetchSingleCourse = id => get(url.FETCH_SINGLE_COURSE + id);

export const fetchAllModuleOfCourse = data => post(url.FETCH_ALL_MODULE__OF_COURSE, data);
export const getFilterCourse = data => post(url.GET_FILTER_COURSE, data);

export const searchCourse = query => get(url.SEARCH_COURSE + query);
